export default __webpack_public_path__ + "assets/images/89200776fca2e29e58c49ce2d2a2caf0.png";